<template>
  <span @click.prevent.stop="unLike" class="close"></span>
</template>
<script setup lang="ts">
import {NaviRequest} from "../../api/NaviRequest";
import {NaviClient} from "../../api/NaviClient";
import {Storage} from "../../localstorage/Storage";
import {ref} from "vue";

const props = defineProps({
  company: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['unlike']);
const company = ref(props.company);

const unLike = () => {
  //ログイン中
  if(globalThis.IS_USER_LOGIN){
    const type = NaviRequest.DELETE;
    NaviClient.favorite(company.value.company_id,type).then((json)=>{
      console.log(json);
    }).catch((error)=>{
      console.log(error);
    });
  }else{
    Storage.deleteFavorite(company.value.company_id);
  }
  emit('unlike',company);
};
</script>